<div class="main-page-wrapper">
    <!-- <div id="preloader" *ngIf="isLoading">
        <div id="ctn-preloader" class="ctn-preloader">
            <div class="txt-loading">
                <span *ngFor="let letter of loadingText" class="letters-loading" [attr.data-text-preloader]="letter">
                    {{ letter }}
                </span>
            </div>
        </div>
    </div> -->

    <app-offcanvas></app-offcanvas>

    <app-slidebar></app-slidebar>

    <router-outlet></router-outlet>

    <a id="scrollToTopBtn" class="progress-wrap" (click)="scrollToTop()" [class.show]="isScrollBtnVisible">
        <i class="bi bi-arrow-up"></i>
    </a>

</div>